module.exports = __webpack_public_path__ + "static/media/v-commerce-1070x660.e88d7a02.jpg";